import { Component, Input, Output, OnInit, OnDestroy, EventEmitter, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatRipple } from '@angular/material/core';

import { AppService } from 'src/app/app.service';
import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';
import { DialogsService } from 'src/app/_services/dialogs.service';

import { SharedOrderManageComponent } from 'src/app/shared-order/shared-order-manage/shared-order-manage.component';

import * as _ from 'lodash';

@Component({
    selector: 'app-tabitpay-ticket',
    templateUrl: './tabitpay-ticket.component.html',
    styleUrls: ['./tabitpay-ticket.component.scss'],
    standalone: false
})
export class TabitpayTicketComponent implements OnInit, OnDestroy {
    @Input() options;
	@Output() onContinue = new EventEmitter<any>();
	@Output() onCheckSelect = new EventEmitter<any>();

	private orderSubscription: Subscription = null;
	private checkSubscription: Subscription = null;

	@ViewChild('ticketRipple', { read: MatRipple }) ticketRipple: MatRipple;

    $storage: any;

    constructor(
		public appService: AppService,
		public tabitPayService: TabitPayService,
		public dialogsService: DialogsService,
		public dialog: MatDialog,
    ) {
		this.$storage = this.tabitPayService.$storage;
		this.checkOrder();
    }

	ngOnInit() {
		this.orderSubscription = this.tabitPayService.orderChanged$.subscribe(() => {
			this.launchRipple();
			this.checkOrder();
		});
		this.checkSubscription = this.tabitPayService.checkChanged$.subscribe(() => {
			this.launchRipple();
			this.checkOrder();
		});
	}

	checkOrder() {
		let _checks = _.get(this.$storage, 'order.checks');
	}

	ngOnDestroy() {
		this.orderSubscription.unsubscribe();
		this.checkSubscription.unsubscribe();
	}

	// --------------------------------------------------------------------->

	launchRipple() {
		const rippleRef = this.ticketRipple.launch(10, 10, {
			persistent: true,
			color: 'rgba(41, 205, 255, 0.52)',
			animation: { enterDuration: 1000, exitDuration:1500 }
		});
		rippleRef.fadeOut();
	}

	_continue(mode?,ev?) {
		//this.launchRipple();
		if (_.get(this.$storage.order, '_order.openTabPayments[0]')) {
			return this.appService.alert({ content: "MESSAGES.PREAUTH_ERROR", contentClass:"m-dialog-message-long" });
		}
        this.onContinue.emit(mode);
	}

	_onCheckSelect(check) {
		this.onCheckSelect.emit(check);
	}
	onTicketAction(args) {
		this._continue(args);
	}
}
